var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcentration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "71.000000pt",
    height: "71.000000pt",
    viewBox: "0 0 71.000000 71.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,71.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 613 c-64 -23 -46 -123 22 -123 55 0 81 83 36 114 -23 17 -33 18 -58 9z m60 -32 c16 -31 12 -49 -15 -67 -23 -15 -27 -15 -50 0 -43 28 -26 86 25 86 19 0 33 -7 40 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 603 c34 -2 88 -2 120 0 31 2 3 3 -63 3 -66 0 -92 -1 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 538 c-16 -25 -108 -59 -180 -68 -99 -11 -124 -30 -121 -95 l1 -40 4 35 c7 56 35 78 112 85 36 4 90 18 120 31 54 24 80 21 69 -8 -5 -13 -65 -46 -120 -67 -20 -8 -28 -17 -28 -36 0 -14 5 -25 10 -25 6 0 10 9 10 20 0 15 14 27 54 44 71 32 100 60 86 86 -5 10 -7 26 -4 34 7 19 -2 21 -13 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 520 c0 -5 23 -10 51 -10 31 0 48 4 44 10 -3 6 -26 10 -51 10 -24 0 -44 -4 -44 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 308 c-21 -30 -20 -54 4 -78 41 -41 100 -13 100 48 0 52 -74 73 -104 30z m78 -4 c34 -34 9 -78 -41 -72 -22 2 -29 9 -31 31 -6 50 38 75 72 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 318 c-42 -33 -15 -108 38 -108 28 0 64 32 64 58 0 50 -63 80 -102 50z m71 -12 c19 -22 9 -68 -15 -77 -29 -10 -64 15 -64 46 0 39 55 60 79 31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 311 c-25 -28 -17 -72 17 -91 24 -13 30 -13 55 0 53 30 33 110 -28 110 -15 0 -35 -9 -44 -19z m78 -10 c33 -37 -12 -93 -56 -70 -40 21 -23 89 22 89 9 0 25 -9 34 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 175 c-22 -15 -36 -52 -23 -60 4 -3 10 6 14 18 10 40 82 60 127 36 11 -5 25 -22 31 -37 10 -24 12 -25 16 -7 3 12 -5 27 -22 42 -32 27 -109 32 -143 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 169 c-14 -11 -26 -27 -26 -36 0 -10 10 -5 29 16 20 22 38 31 60 31 40 0 77 -18 89 -44 9 -17 11 -18 11 -4 2 54 -109 79 -163 37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 165 c-25 -24 -32 -45 -17 -45 4 0 12 10 17 22 21 48 129 48 150 1 5 -13 13 -23 17 -23 15 0 8 21 -17 45 -19 20 -34 25 -75 25 -41 0 -56 -5 -75 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentration);
export default __webpack_public_path__ + "static/media/concentration.18f1b24aa70cf33c8f4def682234367f.svg";
export { ForwardRef as ReactComponent };